var React = require('react');

function TintSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M162.72 255.78L436.4 467.3A174 174 0 0 1 320 512c-97.28 0-176-79.65-176-178.09 0-29.78 7.31-54.63 18.72-78.13zM495.2 351c.52-5.61.8-11.3.8-17 0-111.75-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.5 52.3-36.86 92-58.48 125.68z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.64 480.55L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45z","className":"fa-primary","key":2})]);
}

TintSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = TintSlash;

TintSlash.default = TintSlash;
